export default __webpack_public_path__ + "static/media/PAS.e05c4e62.png";